import React, { FC } from "react";
import "./pointsHistory.scss";
import faker from "faker";
import { Badge, Skeleton } from "antd";
import PointsIcon from "../../../../../../../assets/icons/points.svg";
import { InstituteLeaderboard } from "../../../../../../../models/InstituteModel/leaderboard.model";

interface PointsHistoryProps {
  data: InstituteLeaderboard;
  loading: boolean
}

const PointsHistory: FC<PointsHistoryProps> = (props) => {
  const { data, loading } = props;

  return (
    <div className="points-history">
      {loading
        ? <>
          <div className="points-hisory__card">
            <Skeleton avatar={{shape:'square'}} paragraph={{ rows: 1 }} active></Skeleton>
          </div>
          <div className="points-hisory__card">
          <Skeleton avatar={{shape:'square'}} paragraph={{ rows: 1 }} active></Skeleton>
          </div>
          <div className="points-hisory__card">
          <Skeleton avatar={{shape:'square'}} paragraph={{ rows: 1 }} active></Skeleton>
          </div>
        </>
        : <>
          <h4>Points History</h4>
          {data?.pointHistory?.length ? (
            <div className="points-history__wrapper">
              {data?.pointHistory?.map((value, index) => {
                return (
                  <div className="points-hisory__card">
                    <div className="points-hisory-card__left">
                      {value?.contentThumbnailUrl && (
                        <img
                          className="points-history-content__image"
                          src={value?.contentThumbnailUrl}
                        />
                      )}
                      <div className="points-history-content__container">
                        <div className="points-history-content-title__container">
                          <p className="points-history-content__title" style={{ color: value?.subjectColorCode }}>{value?.subjectThumbnailUrl && <span><img src={value?.subjectThumbnailUrl} /></span>}{value?.subjectName}</p>
                          <Badge status="default" />
                          <p className="points-history-content__type">
                            {value?.fieldType}
                          </p>
                        </div>
                        <div className="points-history-content-title__container">
                          <p className="points-history-content__title">{value?.chapterName}</p>
                          <Badge status="default" />
                          <p className="points-history-content__name">{value?.contentName}</p>
                        </div>
                      </div>
                    </div>
                    <div className="points-hisory-card__right">
                      <p>+{value?.point} </p>
                      <img src={PointsIcon} />
                    </div>
                    <div className="points-hisory-card__right">
                      <p>{value?.counts}{" "}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="no-points-history__text">No points history!</div>
          )}
        </>}
    </div>
  );
};

export default PointsHistory;
